import { createEntityAdapter, createSlice } from '@reduxjs/toolkit';
import { setDefinitions } from '../../actions/SetDefinitions';
const adapter = createEntityAdapter({
    selectId: (x) => x.id,
    sortComparer: (a, b) => a.title.localeCompare(b.title),
});
export const macrosSlice = createSlice({
    name: 'macros',
    initialState: adapter.getInitialState(),
    reducers: {
        macrosCleared(s) { adapter.removeAll(s); },
        macroUpdated(s, a) { adapter.addOne(s, a); },
        macroDeleted(s, a) { adapter.removeOne(s, a); },
        macroReplaced(s, a) { adapter.setAll(s, a); },
    },
    extraReducers: (builder) => {
        builder
            .addCase(setDefinitions, (s, action) => {
            adapter.setAll(s, action.payload.macros);
        });
    }
});
export const { macrosCleared, macroUpdated, macroDeleted, macroReplaced } = macrosSlice.actions;
export const macroAdded = macroUpdated;
export default macrosSlice.reducer;
export const allMacros = adapter.getSelectors().selectAll;
